import idx from 'idx';
import React from 'react';
import { BasicDetailItem } from '../../../components/common/BasicDetailItem';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import { useUserContext } from '../../../context/UserContext';
import {
  getBodyType,
  getBraSize,
  getHeightData,
  getUserUsuallyWears,
} from '../../../helpers/utils';

export const ReviewModalStep1 = ({
  productData,
  userData,
  onClose,
  onPressButton,
}) => {
  const { user, usuallyWears, braSize, heightData, bodyTypes } =
    useUserContext();
  const userName = idx(user, (_) => _.username) || '';
  const userProfilePhoto =
    user &&
    user.review_display_preferences &&
    user.review_display_preferences.profile_photo
      ? 'true'
      : '';

  const renderButtons = () => {
    return (
      <div
        className={'review-button'}
        style={{
          border: 'none',
        }}
      >
        <ButtonWithLoadingIcon
          style={{
            alignSelf: 'flex-start',
            width: '100%',
            marginBottom: 10,
            borderColor: '#2E2B2B',
          }}
          color={'primary'}
          onClick={() => onPressButton()}
        >
          Next
        </ButtonWithLoadingIcon>
      </div>
    );
  };

  return (
    <>
      <div
        style={{
          marginBottom: 100,
          paddingTop: 25,
          paddingLeft: '2.5rem',
          paddingRight: '2.5rem',
          color: '#2E2B2B',
        }}
      >
        {userData?.review_display_preferences?.profile_photo && (
          <BasicDetailItem label='Profile picture' value={userProfilePhoto} />
        )}
        {userData?.review_display_preferences?.username && (
          <BasicDetailItem
            label='Username'
            value={userName}
            makeFirstCharCapital={false}
          />
        )}
        {userData?.review_display_preferences?.usually_wears && (
          <BasicDetailItem
            label='Usually wears'
            value={
              user?.usually_wears
                ? `${getUserUsuallyWears(
                    usuallyWears,
                    user?.usually_wears?.size
                  )}, ${getUserUsuallyWears(
                    usuallyWears,
                    user?.usually_wears?.ussize
                  )}, ${getUserUsuallyWears(
                    usuallyWears,
                    user?.usually_wears?.denim
                  )}`
                : ''
            }
          />
        )}
        {userData?.review_display_preferences?.bra_size && (
          <BasicDetailItem
            label='Bra size'
            value={
              user?.bra_size
                ? `${getBraSize(braSize, user?.bra_size?.band)}${getBraSize(
                    braSize,
                    user?.bra_size?.cup
                  )}`
                : ''
            }
          />
        )}
        {userData?.review_display_preferences?.body_shape && (
          <BasicDetailItem
            label='Body type'
            value={
              user?.body_type ? getBodyType(bodyTypes, user?.body_type) : ''
            }
          />
        )}
        {userData?.review_display_preferences?.age && (
          <BasicDetailItem label='Age' value={user?.age} />
        )}
        {userData?.review_display_preferences?.height && (
          <BasicDetailItem
            label='Height'
            value={
              user?.height
                ? `${getHeightData(
                    heightData,
                    user?.height?.feet
                  )}′ ${getHeightData(heightData, user?.height?.inch)}″`
                : ''
            }
          />
        )}
        {userData?.review_display_preferences?.weight && (
          <BasicDetailItem label='Weight' value={user?.weight} />
        )}
      </div>
      {renderButtons()}
    </>
  );
};
